/** Escape plain text for safe HTML fragments (summary / list items). */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * TipTap/RichInput summary content: sample data uses `<p>...</p>` and `<ul><li><p>...</p></li></ul>`.
 * If the string already looks like HTML, return it unchanged.
 */
export function plainOrHtmlToRichParagraphs(text: string): string {
  const t = text.trim();
  if (!t) {
    return "";
  }
  if (/^\s*</.test(t)) {
    return t;
  }
  const escaped = escapeHtml(t);
  return `<p>${escaped.replace(/\n/g, "<br>")}</p>`;
}

/** Merge JSON Resume work/volunteer narrative + highlights into one RichInput HTML string. */
export function mergeSummaryAndHighlights(
  summary: string | undefined,
  highlights: string[] | undefined,
): string {
  const summaryPart = plainOrHtmlToRichParagraphs(summary?.trim() ?? "");
  const items = highlights?.map((h) => h.trim()).filter(Boolean) ?? [];
  const bulletPart =
    items.length === 0
      ? ""
      : `<ul>${items.map((h) => `<li><p>${escapeHtml(h).replace(/\n/g, "<br>")}</p></li>`).join("")}</ul>`;
  return `${summaryPart}${bulletPart}`;
}
